import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom'
import PrivateRoute from '../PrivateRoute'
import { BASE_URL } from '../../constants/constants'
import Root from '../Root'
import axios from 'axios'
import { connect } from 'react-redux'

//Config
axios.defaults.baseURL = BASE_URL;
class App extends Component {
  render() {
    return (
      <div className="height-100"> 
        <main>
          <Route path="/" component={Root} />
        </main>
      </div>
    )
  }
}



const mapStateToProps = state => {
  return {};
}

export default App;


// WEBPACK FOOTER //
// ./src/containers/App/index.js